module.exports = __webpack_public_path__ + "static/media/sair.234220a6.svg";